"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrayagePorts = void 0;
exports.DrayagePorts = {
    CHI: 'CHI',
    CHS: 'CHS',
    EWR: 'EWR',
    HOU: 'HOU',
    JAX: 'JAX',
    LAX: 'LAX',
    NYC: 'NYC',
    SAV: 'SAV',
    LGB: 'LGB',
    BAY: 'BAY',
    UNKNOWN: 'UNKNOWN'
};
//# sourceMappingURL=drayage-ports.js.map